import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { CONTAINER_ID_PREFIX, DEFAULT_OWNER_ID } from './constants';
import { ensureAdfoxApiAvailable, getRandomContainerId, getCompleteSizes } from './helpers';
import { EventEmitter } from './services/EventEmitter';
import { getCanRunAds } from './helpers/getCanRunAds';
import { jsx as _jsx } from "react/jsx-runtime";
export function connect(Component) {
  var _class;

  return _class = /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    var _super = _createSuper(_class);

    function _class() {
      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "eventEmitter", new EventEmitter());

      _defineProperty(_assertThisInitialized(_this), "state", {});

      _defineProperty(_assertThisInitialized(_this), "handleWindowLoad", function () {
        var canRunAds = getCanRunAds();

        if (canRunAds) {
          var containerId = "".concat(CONTAINER_ID_PREFIX, "_").concat(getRandomContainerId());

          _this.setState({
            containerId: containerId
          }, function () {
            return _this.create(containerId);
          });
        }

        window.removeEventListener('load', _this.handleWindowLoad);
      });

      _defineProperty(_assertThisInitialized(_this), "create", function (containerId) {
        var _window, _window$yaContextCb;

        var _this$props = _this.props,
            ownerId = _this$props.ownerId,
            params = _this$props.params,
            lazyLoad = _this$props.lazyLoad,
            onRegistered = _this$props.onRegistered;
        var adFoxParameters = {
          ownerId: ownerId,
          containerId: containerId,
          params: params,
          lazyLoad: lazyLoad,
          onLoad: _this.handleLoad(containerId),
          onRender: _this.handleRender(containerId),
          onStub: _this.handleStub(containerId),
          onError: _this.handleError(containerId)
        };
        (_window$yaContextCb = (_window = window).yaContextCb) !== null && _window$yaContextCb !== void 0 ? _window$yaContextCb : _window.yaContextCb = [];
        window.yaContextCb.push(function () {
          if (window.Ya && window.Ya.adfoxCode) {
            window.Ya.adfoxCode.create(adFoxParameters);
            onRegistered === null || onRegistered === void 0 ? void 0 : onRegistered(containerId);
          }
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleLoad", function (containerId) {
        return function (data) {
          var _this$props2 = _this.props,
              onLoad = _this$props2.onLoad,
              onLoadStable = _this$props2.onLoadStable;

          _this.eventEmitter.emit({
            event: 'load',
            data: data
          });

          onLoad === null || onLoad === void 0 ? void 0 : onLoad(data, containerId);

          _this.setState({
            bundleName: data.bundleName,
            bundleParams: data.bundleParams
          }, function () {
            _this.eventEmitter.emit({
              event: 'loadStable',
              data: data
            });

            onLoadStable === null || onLoadStable === void 0 ? void 0 : onLoadStable(data, containerId);
          });
        };
      });

      _defineProperty(_assertThisInitialized(_this), "handleRender", function (containerId) {
        return function () {
          var onRender = _this.props.onRender;

          _this.eventEmitter.emit({
            event: 'render'
          });

          onRender === null || onRender === void 0 ? void 0 : onRender(containerId);
        };
      });

      _defineProperty(_assertThisInitialized(_this), "handleStub", function (containerId) {
        return function () {
          var onStub = _this.props.onStub;

          _this.eventEmitter.emit({
            event: 'stub'
          });

          onStub === null || onStub === void 0 ? void 0 : onStub(containerId);
        };
      });

      _defineProperty(_assertThisInitialized(_this), "handleError", function (containerId) {
        return function (error) {
          var onError = _this.props.onError;

          _this.eventEmitter.emit({
            event: 'error',
            error: error
          });

          onError === null || onError === void 0 ? void 0 : onError(error, containerId);
        };
      });

      return _this;
    }

    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        ensureAdfoxApiAvailable(function (error) {
          var _this2$props$onError, _this2$props;

          return (_this2$props$onError = (_this2$props = _this2.props).onError) === null || _this2$props$onError === void 0 ? void 0 : _this2$props$onError.call(_this2$props, error, _this2.state.containerId);
        });

        if (window.document.readyState === 'complete') {
          this.handleWindowLoad();
          return;
        }

        window.addEventListener('load', this.handleWindowLoad);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var containerId = this.state.containerId;

        if (containerId) {
          if (window.Ya && window.Ya.adfoxCode) {
            window.Ya.adfoxCode.destroy(containerId);
          }
        }

        window.removeEventListener('load', this.handleWindowLoad);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            height = _this$props3.height,
            width = _this$props3.width;
        var _this$state = this.state,
            containerId = _this$state.containerId,
            bundleName = _this$state.bundleName,
            bundleParams = _this$state.bundleParams;
        var completeSizes = getCompleteSizes({
          height: height,
          width: width
        });

        if (containerId && Component) {
          return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, completeSizes), {}, {
            containerId: containerId,
            bundleName: bundleName,
            bundleParams: bundleParams,
            eventEmitter: this.eventEmitter
          }));
        }

        return /*#__PURE__*/_jsx("div", {
          id: containerId,
          style: completeSizes
        });
      }
    }]);

    return _class;
  }(React.Component), _defineProperty(_class, "displayName", 'AdFoxBanner'), _defineProperty(_class, "defaultProps", {
    ownerId: DEFAULT_OWNER_ID
  }), _class;
}